import { useState, useEffect } from 'react'
import { useLanguage } from '../context/LanguageContext'

const NAVY = '#002E53'
const GOLD = '#C5A059'
const FONT = "'Poppins', sans-serif"

export default function RecentlySoldSection() {
  const { t, langMeta } = useLanguage()
  const FONT = `"${langMeta.font}", sans-serif`
  const [sold, setSold] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/admin/listings/sold')
      .then(r => r.json())
      .then(data => {
        setSold(data)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  if (loading || sold.length === 0) return null

  return (
    <div style={{ background: '#f8fafb', padding: '80px 20px' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '50px' }}>
          <h2 style={{ fontFamily: FONT, fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 800, color: NAVY, margin: '0 0 16px' }}>{t('recentlySold.title')}</h2>
          <p style={{ fontFamily: FONT, fontSize: '16px', color: '#64748b', maxWidth: '600px', margin: '0 auto' }}>
            {t('recentlySold.desc')}
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px' }}>
          {sold.map((s, i) => {
            const f = s.form || {}
            return (
              <div key={s.id || i} style={{ background: '#fff', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,46,83,0.06)', position: 'relative' }}>
                <div style={{ height: '220px', background: '#e2e8f0', position: 'relative' }}>
                  {s.coverPhoto ? (
                    <img src={s.coverPhoto} alt="Property" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px' }}>🏠</div>
                  )}
                  {/* Sold Badge */}
                  <div style={{ position: 'absolute', top: '16px', right: '16px', background: '#dc2626', color: '#fff', padding: '6px 14px', borderRadius: '8px', fontFamily: FONT, fontSize: '13px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', boxShadow: '0 4px 12px rgba(220,38,38,0.3)' }}>
                    {t('recentlySold.badge')}
                  </div>
                </div>
                <div style={{ padding: '24px' }}>
                  <h3 style={{ fontFamily: FONT, fontSize: '18px', fontWeight: 700, color: NAVY, margin: '0 0 8px' }}>
                    {f.propertyType || 'Property'} in {f.community || f.emirate || 'Dubai'}
                  </h3>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '16px', borderTop: '1px solid #f0f4f8' }}>
                    <div style={{ fontFamily: FONT, fontSize: '18px', fontWeight: 800, color: GOLD }}>
                      {f.currency || 'AED'} {Number(f.askingPrice || 0).toLocaleString()}
                    </div>
                    {f.bedrooms && <div style={{ fontFamily: FONT, fontSize: '13px', color: '#64748b', fontWeight: 600 }}>{f.bedrooms} {t('recentlySold.beds')}</div>}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
